import { makeAutoObservable, runInAction } from 'mobx'

interface Breadcrumb {
  key: string
  label: string
  to?: string
  loading?: boolean
}

/**
 * 只是一个模板，没有实际业务价值
 */
class BreadcrumbStore {
  private _crumbs: Breadcrumb[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get crumbs() {
    return this._crumbs
  }

  set crumbs(value: typeof this._crumbs) {
    runInAction(() => {
      this._crumbs = value
    })
  }
}

export const breadcrumbStore = new BreadcrumbStore()
